import { useTranslation } from 'react-i18next';
import { Box, Link } from '@mui/material';

import ScrollToTop from './ScrollToTop';
import { HomeHeroProvider } from './HomeHeroContext';
import SiteHeader from './SiteHeader';

export default function Root({ children }) {
  const { t } = useTranslation();

  return (
    <HomeHeroProvider>
      <ScrollToTop />
      <SiteHeader />
      {children}
      <Box
        component="footer"
        sx={{
          p: 2,
          display: 'flex',
          justifyContent: 'center',
          gap: 2,
          flexWrap: 'wrap',
        }}
      >
        <Link variant="body2" href="/web-privacy" color="text.secondary" underline="hover">
          {t('nav.webPrivacy')}
        </Link>
        <Link variant="body2" href="/web-offer" color="text.secondary" underline="hover">
          {t('nav.webOffer')}
        </Link>
      </Box>
    </HomeHeroProvider>
  );
}

